enum Color {
  primary = "#3F8AE0",
  primaryHover = "#3C85D7",
  gray = "#222222",
  disabled = "#B8C1CC",
  error = "#FF3347",
  placeholder = "#818C99",
  white = "#FFF",
  border = "#ECEEF3",
  neutralBackground = "#F8FAFD",
  lightGray = "#F1F3F7",
}

export default Color;
